export default __webpack_public_path__ + "static/media/webjars.1fe6865b.png";